/* eslint-disable @next/next/no-before-interactive-script-outside-document */
import Script from 'next/script';
import { ThirdPartyScriptData } from '../response-data-validator';
interface Props {
  gtmData: ThirdPartyScriptData['gtm'];
}
export const GTMHeadScript = ({
  gtmData
}: Props) => {
  if (!gtmData.enabled) return null;
  return <>
            <Script id='gtm-script' strategy='beforeInteractive' dangerouslySetInnerHTML={{
      __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push(
        
                {'gtm.start': new Date().getTime(),event:'gtm.js'}
                );var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','${gtmData.config.containerId}');`
    }} data-sentry-element="Script" data-sentry-source-file="gtm-head.tsx" />

            <Script strategy='beforeInteractive' src='https://www.googletagmanager.com/gtag/js?id=AW-10899030821' defer data-sentry-element="Script" data-sentry-source-file="gtm-head.tsx" />

            <Script strategy='beforeInteractive' id='google-analytics-script' defer dangerouslySetInnerHTML={{
      __html: `window.dataLayer = window.dataLayer || [];
                        function gtag(){dataLayer.push(arguments);}

                        const cookies = document.cookie.split('; ');
                        let user_i = null;
                        let cookie_consent = null;

                        for (let i = 0; i < cookies.length; i++) {
                            const [name, value] = cookies[i].split('=');
                            if (name === 'user_i') {
                                user_i = decodeURIComponent(value);
                            } else if (name === 'cookie_consent') {
                                cookie_consent = decodeURIComponent(value);
                            }

                            if (user_i !== null && cookie_consent !== null) {
                                break;
                            }
                        }
                        const defaultConsentState = (user_i === 'true' || cookie_consent === 'GRANTED') ? 'granted' : 'denied'; 

                        gtag('consent', 'default', {
                            'ad_storage': defaultConsentState,
                            'analytics_storage': defaultConsentState,
                            'ad_user_data': defaultConsentState,
                            'ad_personalization': defaultConsentState,
                        });

                        gtag('js', new Date());
                        
                        gtag('config', 'AW-10899030821');`
    }} data-sentry-element="Script" data-sentry-source-file="gtm-head.tsx" />
        </>;
};